import { CRMActivityEntity, initialCrmActivityEntity } from './CRMActivityEntity';

export interface ActivityFormState {
  isFormOpen: boolean;
  editingActivityId?: number | null;
  formActivity: CRMActivityEntity;
  isInEditMode?: boolean;
}

export const initialFormState: ActivityFormState = {
  isFormOpen: false,
  editingActivityId: null,
  formActivity: { ...initialCrmActivityEntity },
};
